import { analytics } from '../../utility/Analytics';
import { ACTION_ROLE } from '../../shared/Constants';
import { PAGE_NAME, EVENT_NAME } from './segmentConstants';
import { APP_NAME, CMIC_TREE_NODE_TYPES } from '../../shared/Constants';

const versionData = require('../../../../version.json');

const getUserPlatform = () => {
	return navigator?.userAgentData?.platform || navigator?.platform || '';
};

export const segmentIdentifyUser = (loginData, userInfo = {}) => {
	const intercomId = loginData?.intercomId;
	if (!intercomId) return;

	const traits = {
		appName: APP_NAME,
		contactCode: loginData?.contactCode,
		contactName: `${loginData?.firstName || ''} ${loginData?.lastName || ''}`.trim(),
		email: loginData?.email,
		firstName: loginData?.firstName,
		lastName: loginData?.lastName,
		tenantID: userInfo?.tenantID,
		intercomId: loginData?.intercomId,
		intercomAccountCode: loginData?.intercomAccountCode,
		platform: getUserPlatform(),
		timeStamp: new Date(),
	};

	analytics.identify(intercomId, traits);
};

export const segmentTrackLogin = () => {
	const event = EVENT_NAME.LOGIN;
	if (!event) return;

	analytics.track(
		{ event },
		{
			appName: APP_NAME,
			build: versionData?.build || '',
		},
	);
};

export const segmentTrackCall = (eventName, userInfo, obj) => {
	if (userInfo.actionRole === ACTION_ROLE.ECM && userInfo?.isCloudUser) {
		analytics.track({ event: eventName }, obj);
	}
	//console.log({ event: eventName }, obj);
};

export const segmentDefaultTrackCall = (event, obj) => {
	const eventName = EVENT_NAME[event];

	if (eventName) {
		analytics.track({ event: eventName }, obj);
		//console.log({ event: eventName }, obj);
	}
};

export const segmentDefaultPageCall = (pageName, obj) => {
	const name = PAGE_NAME[pageName];
	if (name) {
		analytics.page({ name: name }, obj);
		//console.log(name, obj);
	}
};

export const segmentPageCallDoc = (pageName, obj) => {
	const name = pageName;
	if (name) {
		analytics.page({ name: name }, obj);
		//console.log(name, obj);
	}
};

//This function belongs to the ECM imaging module. It triggers the segment page call when the user clicks on any document type or when a document revision loads.
export const segmentPageCall = (userInfo, data, status) => {
	if (
		data.ecmParentNodeType != CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION &&
		data.ecmParentNodeType != CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE
	) {
		return;
	}
	if (userInfo.actionRole === ACTION_ROLE.ECM && userInfo?.isCloudUser) {
		let obj = {};
		const pageName = PAGE_NAME[data.ecmParentNodeType];
		obj = {
			appName: APP_NAME,
			timeStamp: new Date(),
			contactCode: userInfo?.info?.contactCode,
			imagingSourceName: data?.ImgsSourceDesc,
			imagingDocumentTypeName: data?.ImgdtDocumentTypeDesc,
			status: status ? status : '',
		};

		if (data && data.ecmParentNodeType === CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION) {
			((obj.parentImagingDocumentName = data.ImgdDocumentName),
				(obj.imagingSourceName = data?.ImgdSourceDesc),
				(obj.imagingDocumentTypeName = data?.ImgdDocumentTypeDesc));
		}
		analytics.page({ name: pageName }, obj);
	}
	// console.log({ name: pageName }, obj);
};

export const triggerSegmentTrackCall = (data, objServerSettings, status, nodeType, resp = {}) => {
	const eventName = EVENT_NAME[data.ecmParentNodeType];
	if (eventName) segmentTrackCall(eventName, objServerSettings, createSegmentObject(data, objServerSettings, status));
	else if (data.num) {
		paginationSegmentTrackCall(data, objServerSettings, status, nodeType, resp);
	}

	if (objServerSettings.actionRole === ACTION_ROLE.PROJECT && objServerSettings?.isCloudUser) {
		if (nodeType === CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS) {
			const event = 'PM_DOCUMENT';
			const obj = {
				contactCode: objServerSettings?.info?.contactCode,
				timestamp: new Date(),
				projectName: data?.PmpProjName,
				projectId: data?.PmpVUuid,
				status: status,
			};
			segmentDefaultTrackCall(event, obj);
		}

		if (nodeType === CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE) {
			const PAGE_NAME = data?.PmdgtTypeName + ' Folder Clicked';
			const obj = {
				contactCode: objServerSettings?.info?.contactCode,
				timestamp: new Date(),
				projectName: objServerSettings?.PmpProjName,
				projectId: objServerSettings?.PmpVUuid,
				documentTypeName: data?.PmdgtTypeName,
				documentTypeCode: data?.PmdgtTypeCode,
				status: status,
			};
			segmentPageCallDoc(PAGE_NAME, obj);
		}
	}
};

// Creating a Segment track call object when the user selects any document type.
const createSegmentObject = (data, userInfo, status) => {
	return {
		contactCode: userInfo?.info?.contactCode,
		timeStamp: new Date(),
		imagingSourceId: data?.ImgsdtSourceUuid,
		imagingSourceName: data?.ImgsSourceDesc,
		imagingDocumentTypeId: data?.ImgdtVUuid,
		imagingDocumentTypeName: data?.ImgdtDocumentTypeDesc,
		status: status,
	};
};

export const triggerSegmentPageCall = (data, objServerSettings, status, nodeType, resp = {}) => {
	const pageName = PAGE_NAME[data.ecmParentNodeType];
	if (pageName) segmentPageCall(objServerSettings, data, status);
	else if (data.num) {
		paginationSegmentPageCall(data, objServerSettings, status, nodeType, resp);
	}
};

const paginationSegmentPageCall = (data, userInfo, status, nodeType, resp) => {
	if (
		nodeType != CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION &&
		nodeType != CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE
	) {
		return;
	}
	const pageName = PAGE_NAME['PAGINATION'];
	if (pageName) {
		let obj = {};
		if (userInfo.actionRole === ACTION_ROLE.ECM && userInfo?.isCloudUser) {
			obj = {
				appName: APP_NAME,
				timeStamp: new Date(),
				contactCode: userInfo?.info?.contactCode,
				imagingSourceName: userInfo?.ImgsSourceDesc,
				pageNumber: data.num + 1,
				status: status ? status : '',
			};

			if (nodeType === CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE) {
				((obj.document = 'New'),
					(obj.imagingDocumentTypeId = resp ? resp.ImgdtVUuid : data.nodeId || data.value));
				obj.imagingDocumentTypeName = resp?.ImgdDocumentTypeDesc;
			} else if (nodeType === CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION) {
				((obj.document = 'Revision'), (obj.imagingDocumentId = data.nodeId || data.value));
				obj.imagingDocumentTypeId = resp ? resp.ImgdtVUuid : '';
				obj.imagingDocumentTypeName = data?.documentTypeName;
				obj.imagingDocumentName = data?.documentName;
			}
			analytics.page({ name: pageName }, obj);
		}
		//console.log({ name: pageName }, obj);
	}
};

const paginationSegmentTrackCall = (data, userInfo, status, nodeType, resp) => {
	if (
		nodeType != CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION &&
		nodeType != CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE
	) {
		return;
	}
	const eventName = EVENT_NAME['PAGINATION'];
	if (eventName) {
		let obj = {};
		if (userInfo.actionRole === ACTION_ROLE.ECM && userInfo?.isCloudUser) {
			obj = {
				contactCode: userInfo?.info?.contactCode,
				timeStamp: new Date(),
				imagingSourceId: userInfo?.ImgsVUuid,
				imagingSourceName: userInfo?.ImgsSourceDesc,
				pageNumber: data.num + 1,
				status: status ? status : '',
			};

			if (nodeType === CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE) {
				obj.document = 'New';
				obj.imagingDocumentTypeId = resp ? resp.ImgdtVUuid : data.nodeId || data.value;
				obj.imagingDocumentTypeName = resp?.ImgdDocumentTypeDesc;
			} else if (nodeType === CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION) {
				obj.document = 'Revision';
				obj.imagingDocumentId = data.nodeId || data.value;
				obj.imagingDocumentTypeId = resp ? resp.ImgdtVUuid : '';
				obj.imagingDocumentTypeName = data?.documentTypeName;
				obj.imagingDocumentName = data?.documentName;
			}
			segmentTrackCall(eventName, userInfo, obj);
		}
	}
};
